// extracted by mini-css-extract-plugin
export default {"skip":"correspondence_skip__V3G7F","btnHolder":"correspondence_btnHolder__hjmhT index_btnHolder__qk4lM"};